const ShopAndLearn = [
    {
        id: 1,
        name: "Store",
        link: "https://www.apple.com/kr/store",
    },
    {
        id: 2,
        name: "Mac",
        link: "https://www.apple.com/kr/mac/",
    },
    {
        id: 3,
        name: "iPad",
        link: "https://www.apple.com/kr/ipad/",
    },
    {
        id: 4,
        name: "iPhone",
        link: "https://www.apple.com/kr/iphone/",
    },
];

const Services = [
    {
        id: 1,
        name: "Apple One",
        link: "https://www.apple.com/kr/apple-one/",
    },
    {
        id: 2,
        name: "Apple TV+",
        link: "https://www.apple.com/kr/apple-tv-plus/",
    },
    {
        id: 3,
        name: "Apple Music",
        link: "https://www.apple.com/kr/apple-music/",
    },
    {
        id: 4,
        name: "Apple Arcade",
        link: "https://www.apple.com/kr/apple-arcade/",
    },
    {
        id: 5,
        name: "Apple Podcasts",
        link: "https://www.apple.com/kr/apple-podcasts/",
    },
    {
        id: 6,
        name: "Apple Books",
        link: "https://www.apple.com/kr/apple-books/",
    },
    {
        id: 7,
        name: "App Store",
        link: "https://www.apple.com/kr/app-store/",
    },
];

const AppleStore = [
    {
        id: 1,
        name: "매장 찾기",
        link: "https://www.apple.com/kr/retail/",
    },
    {
        id: 2,
        name: "Genius Bar",
        link: "https://www.apple.com/kr/retail/geniusbar/",
    },
    {
        id: 3,
        name: "Today at Apple",
        link: "https://www.apple.com/kr/today/",
    },
    {
        id: 4,
        name: "Apple 캠프",
        link: "https://www.apple.com/kr/today/camp/",
    },
    {
        id: 5,
        name: "Apple Store 앱",
        link: "https://itunes.apple.com/kr/app/apple-store/id375380948?mt=8",
    },
    {
        id: 6,
        name: "인증 리퍼비쉬 제품",
        link: "https://itunes.apple.com/kr/app/apple-store/id375380948?mt=8",
    },
    {
        id: 7,
        name: "Apple Trade In",
        link: "https://itunes.apple.com/kr/app/apple-store/id375380948?mt=8",
    },
    {
        id: 8,
        name: "할부 방식",
        link: "https://itunes.apple.com/kr/app/apple-store/id375380948?mt=8",
    },
    

];

const FooterLinks = [
    {
        id: 1,
        name: "개인정보 처리방침",
        link: "https://www.apple.com/kr/privacy/privacy-policy",
    },
    {
        id: 2,
        name: "약관",
        link: "https://www.apple.com/kr/legal/internet-services/terms/site.html",
    },
    {
        id: 3,
        name: "판매 및 환불",
        link: "https://www.apple.com/kr/shop/open/salespolicies",
    },
    {
        id: 4,
        name: "법적 고지",
        link: "https://www.apple.com/kr/legal",
    },
    {
        id: 5,
        name: "사이트 맵",
        link: "https://www.apple.com/kr/shop/browse/sitemap",
    },
];

const AboutApple = [
    {
        id: 1,
        name: "Newsroom",
        link: "https://www.apple.com/kr/newsroom/",
    },
    {
        id: 2,
        name: "Apple 리더십",
        link: "https://www.apple.com/kr/leadership/",
    },
    {
        id: 3,
        name: "채용안내",
        link: "https://www.apple.com/jobs/kr/",
    },
    {
        id: 4,
        name: "윤리 및 규정준수",
        link: "https://www.apple.com/compliance",
    },
    {
        id: 5,
        name: "이벤트",
        link: "https://www.apple.com/kr/apple-events/",
    },
    {
        id: 6,
        name: "일자리 창출",
        link: "https://www.apple.com/kr/job-creation/",
    },
    {
        id: 7,
        name: "Apple 연락처",
        link: "https://www.apple.com/kr/contact/",
    },
]

export { ShopAndLearn, Services, AppleStore, FooterLinks, AboutApple };